import { arrayOf, number, shape, string } from 'prop-types'

import { omit } from 'shared/utils/objectUtils'

const navigation = {
  content: string.isRequired,
  deepLink: string.isRequired,
  domain: string.isRequired,
  pageId: string.isRequired,
  pageNumber: string.isRequired,
  requestUrl: string.isRequired,
  siteType: string.isRequired,
  vcontent: string,
}

const request = {
  adword: string.isRequired,
  newsletter: string.isRequired,
  product: string.isRequired,
  quantity: string.isRequired,
}

const econda = {
  siteId: string.isRequired,
  countryid: string.isRequired,
}

const product = {
  basicPrice: string.isRequired,
  brand: string.isRequired,
  bz: string.isRequired,
  categoryPath: string.isRequired,
  famId: string.isRequired,
  id: string.isRequired,
  linkedCategory: string.isRequired,
  manufacturer: string.isRequired,
  name: string.isRequired,
  pharmaForm: string.isRequired,
  priceBrutto: string.isRequired,
  priceNetto: string.isRequired,
  quantity: string.isRequired,
  substances: string.isRequired,
  unit: string.isRequired,
  unitQuantityString: string.isRequired,
}

const app = {
  name: string.isRequired,
  env: string.isRequired,
  version: string.isRequired,
}

const filterData = {
  filter: string.isRequired,
  filterName: string.isRequired,
  hits: number.isRequired,
}

export const dataLayer = {
  countryCode: string.isRequired,
  econda: shape(econda).isRequired,
  filterData: arrayOf(shape(filterData)),
  languageCode: string.isRequired,
  navigation: shape(navigation).isRequired,
  product: shape(product).isRequired,
  request: shape(request).isRequired,
  app: shape(app).isRequired,
}

export const nonProductDataLayer = {
  countryCode: string.isRequired,
  econda: shape(econda).isRequired,
  filterData: arrayOf(shape(filterData)),
  languageCode: string.isRequired,
  navigation: shape(navigation).isRequired,
  request: shape(omit(request, ['product', 'quantity'])).isRequired,
  app: shape(app).isRequired,
}
